import normalizedActions from "../utils/normalized/actions";
import PromotionProgress, { ModelType } from "./model";

const createPromotionProgressFromData = (data) => {
  const promotionProgress = new PromotionProgress();
  promotionProgress.deserialize(data);
  return promotionProgress;
};

export function addPromotionProgress(data, associations) {
  return (dispatch, getState) => {
    return normalizedActions.updateOrCreateModel(
      dispatch,
      getState().promotionProgress,
      ModelType,
      data,
      associations,
    );
  };
}

export function addPromotionProgressFromNormalizedData(data, associations) {
  return (dispatch) => {
    const promotionProgress = createPromotionProgressFromData(data);
    dispatch(addPromotionProgress(promotionProgress, associations));
  };
}

export function removePromotionProgress(id) {
  return (dispatch) => {
    return normalizedActions.removeModel(dispatch, ModelType, id);
  };
}

export function addPromotionProgressesFromGraphQL(promotionProgressData) {
  return (dispatch) => {
    promotionProgressData.forEach((data) => {
      const promotionProgress = createPromotionProgressFromData(data);
      dispatch(addPromotionProgress(promotionProgress));
    });
  };
}
